<h2 mat-dialog-title>
  <mat-icon>move_down</mat-icon>
  Flyt brik fra en afdeling til en anden
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
@if (idTagSignal()) {
  @let idTag = idTagSignal();
  <form [formGroup]="departmentSwitchForm" (ngSubmit)="saveDepartmentSwitch()">
    <mat-dialog-content>
      @if (wasSaved()) {
        <div class="form-row">
          <ok-feedback-success>
            Brikken blev flyttet til <em>{{ departmentSwitchForm.controls['selectedDepartment'].value?.name }}</em>
          </ok-feedback-success>
        </div>
      } @else {
        <div class="form-row">
          <ok-feedback-info>
            <p>
              Brikken er lige nu tilknyttet <span class="bold">{{ currentDepartment()?.name }}</span> og status for brikken er
              <span class="bold">{{ idTag?.status | translateIdTagStatusEnum }}</span>
            </p>
          </ok-feedback-info>
        </div>
        @if (isInactivateAndCreate) {
          <div class="form-row">
            <p>Skift til en af nedenstående afdelinger</p>
            <adm-dep-typeahead
              [organizationId]="idTag?.organizationId ?? null"
              [excludedDepartmentId]="idTag?.departmentId ?? null"
              (itemSelected)="departmentSelected($event)"
              [resetTrigger]="resetDepartmentTrigger()" />
          </div>
          <div class="form-row">
            <ok-feedback-info> Ved ændring af afdeling, vil betaling for nyt forbrug faktureres på valgte afdeling. </ok-feedback-info>
          </div>
          <div class="form-row">
            <div>
              <adm-g4-agreement-number [control]="departmentSwitchForm.controls.agreementNumber" />
              <mat-hint class="tiny-text">
                Indtastet aftalenr. bliver brugt til at fakturere alt forbrug for brikkerne tilknyttet brugeren
              </mat-hint>
            </div>
          </div>
        }
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <div class="unit-identifier">
        @if (idTag?.printedId) {
          <span>Brik ID:</span>
        } @else {
          <span>Brik beskrivelse:</span>
        }
        {{ idTag?.printedId ? idTag?.printedId : idTag?.description }}
      </div>
      @if (wasSaved()) {
        <button class="actions__button" type="button" [disabled]="saving()" mat-button (click)="close()">Luk</button>
      }
      @if (!wasSaved()) {
        <button class="actions__button margin--right-2" type="button" mat-button mat-dialog-close>Annuller</button>
      }
      @if (!wasSaved()) {
        <button
          class="actions__button"
          type="submit"
          [disabled]="isSubmitDisabled()"
          [class.spinner]="saving()"
          mat-flat-button
          color="primary">
          Gem
        </button>
      }
    </mat-dialog-actions>
  </form>
}
